import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 41 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M17.625 19H11.3125C5.3125 19 0.5 23.875 0.5 29.875C0.5 31.0625 1.4375 32 2.625 32H26.3125C27.5 32 28.5 31.0625 28.5 29.875C28.5 23.875 23.625 19 17.625 19ZM3.5 29C3.9375 25.125 7.25 22 11.3125 22H17.625C21.6875 22 24.9375 25.125 25.4375 29H3.5ZM14.5 16C18.875 16 22.5 12.4375 22.5 8C22.5 3.625 18.875 0 14.5 0C10.0625 0 6.5 3.625 6.5 8C6.5 12.4375 10.0625 16 14.5 16ZM14.5 3C17.25 3 19.5 5.25 19.5 8C19.5 10.8125 17.25 13 14.5 13C11.6875 13 9.5 10.8125 9.5 8C9.5 5.25 11.6875 3 14.5 3ZM40 8.4375C39.375 7.875 38.4375 7.875 37.875 8.5L32.4375 14.375L30 12C29.4375 11.375 28.5 11.375 27.9375 12C27.3125 12.5625 27.3125 13.5 27.9375 14.0625L31.4375 17.5625C31.6875 17.875 32.0625 18 32.5 18C32.875 18 33.3125 17.875 33.5625 17.5625L40.0625 10.5625C40.625 9.9375 40.625 9 40 8.4375Z",
		fill: "#DA7600"
	})]
});
const ForwardRef = forwardRef(SvgUserCheck);
export { ForwardRef as ReactComponent };
